import { type FC, useState } from "react";

import { Check, ChevronDown, ChevronUp, X } from "lucide-react";

interface WhatCountsSectionProps {
  personFirstName: string;
}

const INCLUDE_ITEMS = (name: string) => [
  `Bank accounts in ${name}'s name only`,
  `A home or car titled in ${name}'s name only`,
  "Investment or retirement accounts with no named beneficiary",
  "Valuables like jewelry, art, or collections",
];

const EXCLUDE_ITEMS = [
  "Anything owned jointly with someone else",
  "Accounts or policies with a named beneficiary",
  "Debts, like a mortgage or credit cards",
];

export const WhatCountsSection: FC<WhatCountsSectionProps> = ({ personFirstName }) => {
  const [open, setOpen] = useState(false);
  const personName = personFirstName || "the person who passed";

  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2"
      >
        <p className="text-sm font-medium text-brand">What counts?</p>
        {open ? (
          <ChevronUp className="h-5 w-5 text-brand" />
        ) : (
          <ChevronDown className="h-5 w-5 text-brand" />
        )}
      </button>

      {open && (
        <div className="flex gap-4 rounded-lg border border-primary bg-white p-4">
          <div className="flex flex-1 flex-col gap-2">
            <p className="text-sm font-medium">Include</p>
            {INCLUDE_ITEMS(personName).map((text) => (
              <div key={text} className="flex items-start gap-2">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                <p className="text-sm text-secondary">{text}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-1 flex-col gap-2">
            <p className="text-sm font-medium">Don't include</p>
            {EXCLUDE_ITEMS.map((text) => (
              <div key={text} className="flex items-start gap-2">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-destructive" />
                <p className="text-sm text-secondary">{text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
